var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { atomStore, translationsAtom, localeAtom } from "../V2/atoms";
import translate, { getLocaleTranslation, getContext } from "../../shared/translate";
import { Translate } from "./Translate";

//return type as any since there is no way to create conditional returns based on parameters










const t = (
contextId,
key,
text,
returnComponent = true,
truncate = undefined) =>
{
  if (!contextId) {
    // eslint-disable-next-line no-console
    console.warn(`You cannot translate "${key}", because context id is "${contextId}"`);
  }

  if (returnComponent) {
    return (/*#__PURE__*/
      _jsx(Translate, { context: contextId, truncate: truncate }, void 0,
      key
      ));

  }

  const translations = atomStore.get(translationsAtom);
  const locale = atomStore.get(localeAtom);
  const context = getContext(getLocaleTranslation(translations, locale), contextId);
  const translatedText = translate(context, key, text || key);
  const requiresTruncation = truncate && translatedText.length > truncate;
  return requiresTruncation ? `${translatedText.slice(0, truncate)}...` : translatedText;
};

export { t };